/**
 *
 * @author yangxin
 * @date  2020-06-03
 */

const routePath = {
  OVERVIEW_INTRO: '/',
  OVERVIEW_BUSINESS: '/overview/business',
  OVERVIEW_LONGTERM: '/overview/longterm',
  OVERVIEW_INVESTOR: '/overview/investor',
  COMPANY: '/company',
  COMPANY_PROFILE: '/company/profile',
  COMPANY_MANAGEMENT: '/company/management',
  COMPANY_DIRECTORS: '/company/directors',
  FINANCIAL: '/financial',
  FINANCIALS_QUANTERLY_EARNINGS: '/financial/quanterlyEarnings',
  FINANCIALS_DATA: '/financial/data',
  FINANCIALS_ANNUAL_REPORT: '/financial/annualReport',
  FINANCIALS_SEC: '/financial/sec',
  EVENT: '/event',
  EVENT_INVESTOR: '/event/investor',
  EVENT_INVESTOR_DETAIL: '/event/investor/:eventId',
  EVENT_CALENDAR: '/event/calendar',
  EVENT_NEWS: '/event/news',
  EVENT_NEWS_DETAIL: '/event/news/:newsId',
  STOCK_INFO: '/stock',
  STOCK_INFO_QUOTE_CHART: '/stock/stockQuoteChart',
  STOCK_INFO_ANALYST_COVERAGE: '/stock/alalystCoverage',
  GOVERNANCE: '/governance',
  GOVERNANCE_CORPORATE: '/governance/corporate',
  GOVERNANCE_COMMITTEES: '/governance/committees',
  RESOURCE: '/resource',
  RESOURCE_EMAIL: '/resource/email',
  RESOURCE_CONTACT: '/resource/contact',
  INTRO_VIDEOS: '/introVideos',
  // REPORT_INTRO_VIDEOS: '/introVideos/:reportId',
  REPORT_INTRO_VIDEOS: '/introVideos/videoFlow',
  UNSUBSCRIBE: '/unsubscribe/:code',
  LIVE_BROADCAST: '/live',
}

export type RoutePathName = keyof typeof routePath

export default routePath
